import { PlusCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import { buttonClasses } from 'shared/components/Button';
import { useClientNames } from 'shared/hooks/useClientNames';
import EventoFiltersBar from '../components/EventoFiltersBar';
import EventoTable from '../components/EventoTable';
import { useEventos } from '../hooks/useEventos';

const EventosListPage = () => {
  const {
    events,
    total,
    isLoading,
    reload,
    filters,
    page,
    rowsPerPage,
    columnVisibility,
    onFiltersChange,
    onChangePage,
    onChangeRowsPerPage,
    resetFilters,
    setColumnVisibility,
    toggleActive,
    deleteEvent
  } = useEventos();
  const { clientesQuery } = useClientNames(false);

  return (
    <div className="min-h-screen bg-page-light dark:bg-page-dark">
      <PageHeader
        area="Inventarios"
        title="Eventos"
        subArea="Gestión de Eventos"
        toolbar={
          <Link
            to="/main/inventories/events/create"
            className={buttonClasses('primary', 'sm')}
          >
            <PlusCircle size={16} />
            Nuevo evento
          </Link>
        }
      />
      <PageContainer lessMargin>
        <div className="flex w-full flex-col">
          <div
            className="sticky bg-page-light pb-3 dark:bg-page-dark"
            style={{ top: '0px', zIndex: 2 }}
          >
            <EventoFiltersBar
              filters={filters}
              clients={clientesQuery.data ?? []}
              columnVisibility={columnVisibility}
              isLoading={isLoading}
              onFiltersChange={onFiltersChange}
              onResetFilters={resetFilters}
              onColumnVisibilityChange={setColumnVisibility}
              onRefresh={reload}
            />
          </div>
          <EventoTable
            events={events}
            total={total}
            page={page}
            rowsPerPage={rowsPerPage}
            isLoading={isLoading}
            columnVisibility={columnVisibility}
            onChangePage={onChangePage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onToggleActive={toggleActive}
            onDelete={(event) => deleteEvent(event.id)}
          />
        </div>
      </PageContainer>
    </div>
  );
};

export default EventosListPage;
